/**
 * Форматирует дату из вида YYYY-MM-DD в DD.MM.YYYY
 * @param {string} date
 * @return {string}
 */
export default function formatDate(date) {
  const [year, month, day] = date.split('-');
  return `${day}.${month}.${year}`;
}
